var React = require('react');

function IconLinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.4167 29.75H12.75V12.75H18.4167V15.5833C19.6246 14.0466 21.4563 13.1305 23.4104 13.0857C26.9246 13.1053 29.7602 15.965 29.75 19.4792V29.75H24.0833V20.1875C23.8567 18.6046 22.4992 17.4301 20.9001 17.4335C20.2006 17.4556 19.5404 17.7618 19.0718 18.2815C18.6032 18.8012 18.3666 19.4895 18.4167 20.1875V29.75ZM9.91667 29.75H4.25V12.75H9.91667V29.75ZM7.08333 9.91667C5.51853 9.91667 4.25 8.64814 4.25 7.08333C4.25 5.51853 5.51853 4.25 7.08333 4.25C8.64814 4.25 9.91667 5.51853 9.91667 7.08333C9.91667 7.83478 9.61816 8.55545 9.0868 9.0868C8.55545 9.61816 7.83478 9.91667 7.08333 9.91667Z","fill":"white"}));
}

IconLinkedinInline.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = IconLinkedinInline;

IconLinkedinInline.default = IconLinkedinInline;
